module.exports = __webpack_public_path__ + "components/social-bubble/static/instagram-178dba441287320186a93fd457f8a95e.svg";